import React, { useState } from "react";
import "../../css/ParentEngagements.css";
import SchoolHero from "../SchoolLevels/SchoolHero";

const COMMUNICATION_MODES = [
  { icon: "🧑‍🏫", name: "Parent-Teacher Meetings" },
  { icon: "🗣️", name: "1:1 Meetings" },
  { icon: "📅", name: "Weekly Class Updates" },
  { icon: "🎓", name: "Orientation Sessions" },
];

const FAQ_ITEMS = [
  {
    q: "How does Sahara Public School keep parents informed?",
    a: "We use a mix of parent-teacher meetings, one-on-one sessions, weekly class updates, and a dedicated parent portal to keep communication open and consistent.",
  },
  {
    q: "Is there a portal for parents to track school updates?",
    a: "Yes, our parent portal acts as a one-stop hub for announcements, queries, invoicing, transport updates, and other school-related information.",
  },
  {
    q: "Can parents get involved in school activities?",
    a: "Absolutely. Parents can take part in classroom sessions, special days, and volunteer opportunities, and can also join our parent ambassador community.",
  },
];

export default function ParentEngagements() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <div className="pe-page">
      {}
      <SchoolHero
        title="Parent Engagement"
        subtitle="World-Class Infrastructure"
        image="/images/pe.jpeg"
      />
      <section className="pe-hero">
        <h1>Parent Engagement</h1>
        <p>
          Parents are kept involved at every step through special events and
          one-on-one sessions.
        </p>
      </section>

      {}
      <section className="wrap pe-intro">
        <div>
          <h2>Open Communication, Every Day</h2>
          <p>
            Open communication between parents and the school is an essential
            part of student progress — a practice we sustain on a daily basis at
            Sahara Public School.
          </p>
          <p>
            We recognise the important role effective parent-teacher-student
            communication plays in helping students reach their full potential
            and grow in a supportive environment.
          </p>
        </div>
        <div className="pe-intro-img">
          <span className="emoji-badge">🤝</span>
        </div>
      </section>

      {}
      <section className="pe-portal">
        <div className="pe-portal-card">
          <h3>Parent Portal</h3>
          <p>
            Our dedicated parent portal is a one-stop solution for
            announcements, queries, and everyday administrative tasks like
            invoicing and transport updates.
          </p>
          <p>
            It acts as a bridge between teachers and parents, with feedback and
            support requests routed to the right person so every query gets a
            prompt response.
          </p>
        </div>
      </section>

      {}
      <section className="pe-grid-section">
        <div className="wrap">
          <h2>Other Modes of Communication</h2>
          <div className="pe-grid">
            {COMMUNICATION_MODES.map((m) => (
              <div className="pe-card" key={m.name}>
                <div className="pe-icon">{m.icon}</div>
                <div className="pe-name">{m.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {}
      <section className="wrap pe-section">
        <div>
          <h2>Calendar Activities</h2>
          <p>
            Events like Annual Day and Sports Day are held every year as
            showcase moments for students to display their talent in sports and
            co-curricular activities.
          </p>
          <p>
            Students from all four Houses take part in these events and compete
            for top honours, building character, camaraderie, and a healthy
            hunger to win for collective pride.
          </p>
        </div>
        <div className="pe-section-img">
          <span className="emoji-badge">🏆</span>
        </div>
      </section>

      {}
      <section className="wrap pe-section reverse">
        <div>
          <h2>Special Days</h2>
          <p>
            Special days in our pre-primary classes aim to strengthen bonds
            between students and their extended families.
          </p>
          <p>
            Parents often join classroom activities like storytelling sessions,
            projects, and drama lessons, while grandparents are welcomed through
            events like Grandparents' Day. Parents also share their expertise
            through talks and volunteer their time during school trips and
            events.
          </p>
        </div>
        <div className="pe-section-img">
          <span className="emoji-badge">👨‍👩‍👧‍👦</span>
        </div>
      </section>

      {}
      <div className="pe-ambassadors">
        <p>
          Our Parent Ambassador community works closely with the school and
          shares their experiences with other families
        </p>
      </div>

      {}
      <section className="wrap pe-faq">
        <h2>Frequently Asked Questions</h2>
        {FAQ_ITEMS.map((item, idx) => {
          const isOpen = openFaq === idx;
          return (
            <div className="faq-mini-item" key={item.q}>
              <button
                type="button"
                className="faq-mini-question"
                onClick={() => setOpenFaq(isOpen ? -1 : idx)}
              >
                <span>{item.q}</span>
                <span>{isOpen ? "−" : "+"}</span>
              </button>
              {isOpen && <p className="faq-mini-answer">{item.a}</p>}
            </div>
          );
        })}
      </section>
    </div>
  );
}
